import { memo, useCallback, type ReactNode } from 'react';
import get from 'lodash/get';
import PhoneInput from 'react-phone-number-input';
import { areEqualFields } from 'utils/form';
import valueProp from '../valueProp';
import type { TFieldComponentProps } from '../types';
import s from './PhoneNumberInput.module.scss';
import 'react-phone-number-input/style.css';

export interface IPhoneNumberInputProps extends TFieldComponentProps<string | null | undefined> {
  label?: ReactNode;
}

const PhoneNumberInput = ({ field, form, label }: IPhoneNumberInputProps) => {
  const { name } = field;
  // The value may be null (the typings say string or undefined); it is passed on as it is.
  const { value, ...fieldProps } = field;
  const { touched, errors, setFieldValue, setFieldTouched } = form;

  const handleChange = useCallback(
    (v?: string) => {
      setFieldValue(name, v);
    },
    [name, setFieldValue],
  );

  const handleOnBlur = useCallback(() => {
    setFieldTouched(name, true);
  }, [name, setFieldTouched]);

  return (
    <div className={s.fieldWrapper}>
      <label htmlFor={name} className={s.label} id={`label-${name}`}>
        {label}
      </label>
      <PhoneInput
        {...fieldProps}
        {...valueProp(value)}
        limitMaxLength
        smartCaret
        international
        countryCallingCodeEditable={false}
        autoComplete="none"
        defaultCountry="AT"
        onChange={handleChange}
        onBlur={handleOnBlur}
        className={s.numberInput}
      />
      {get(touched, name) && get(errors, name) ? (
        <div className="error-text">{get(errors, name)}</div>
      ) : null}
    </div>
  );
};

export default memo(PhoneNumberInput, areEqualFields);
